"use client";

import {usePathname, useSearchParams} from "next/navigation";
import {useEffect} from "react";
import Script from "next/script";

const YM_COUNTER_ID = 105134749;
const base = "https://formula.autogarantcity.ru";

export const YandexMetrika = () => {
    const pathName = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        const params = searchParams.toString();
        const url = base + pathName + (params && "?" + params);

        ym(YM_COUNTER_ID, "hit", url);
    }, [pathName, searchParams]);

    return (
        <Script id="metrika">
            {`
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
 
        ym(105134749, "init", {
          defer: true,
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true
        });    
      `}
        </Script>
    );
};